module.exports = __webpack_public_path__ + "static/media/8.31053a16.jpg";